import { TextCodes } from '@api/types/translation/TextCodes';
import { useCart } from '@hooks/cart/cart.hooks';
import { AddShoppingCart } from '@mui/icons-material';
import { Box, Button, ButtonProps, styled } from '@mui/material';
import { t } from '@translations';

// STYLES
//--------

const SubmitButton = styled(Button)`
  min-width: 0;
  flex-grow: 1;
`;

// TYPES
//--------
export type AddToCartProps = {
  code: string;
  name?: string;
  showLabel?: boolean;
  quantity?: number;
  size?: ButtonProps['size'];
};

// COMPONENTS
//------------
export const AddToCartButton = ({ code, showLabel, name, quantity = 1, size }: AddToCartProps) => {
  // Trigger request
  //const [trigger, status] = useAddCartItemMutation();
  const { addToCart, addToCartStatus } = useCart();

  const clickHandler = () => {
    addToCart(code, quantity, name);
  };

  // Data & class names
  const { isLoading } = addToCartStatus;
  const isWorking = isLoading;

  return (
    <SubmitButton
      variant='secondary'
      onClick={clickHandler}
      startIcon={showLabel && <AddShoppingCart />}
      className='submit-button'
      disabled={isWorking}
      size={size}
    >
      {showLabel ? (
        <Box component='span'>{t(TextCodes.Product.Cart.AddToCart)}</Box>
      ) : (
        <AddShoppingCart />
      )}
    </SubmitButton>
  );
};
